import { useState } from 'react'
import { Modal } from '@lunary/ui-web/modal'
import { deckErrorText } from './errors'
import { KIND_TITLE, KINDS } from './kinds'
import { useCreateDeck } from './queries'
import type { DeckKind } from './queries'
import styles from './decks.module.css'

const POINTS: Record<DeckKind, readonly string[]> = {
  three_cards: ['78 карт: 22 старших и 4 масти по 14', 'Набор фиксирован, свои карты не добавляются', 'Карты в «Трёх картах» выпадают случайно'],
  daily_card: ['Изначально 22 старших аркана', 'Можно добавить свои карты', 'Карту дня выбирают вручную'],
}

type Props = { open: boolean; onClose: () => void; onCreated: (id: string) => void }

export function CreateDeckDialog({ open, onClose, onCreated }: Props) {
  const create = useCreateDeck()
  const [kind, setKind] = useState<DeckKind>('daily_card')
  const [name, setName] = useState('')
  const trimmed = name.trim()

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Для чего эта колода?"
      description="Тип выбирается один раз и потом не меняется."
      onSubmit={(e) => {
        e.preventDefault()
        if (!trimmed) return
        create.mutate(
          { name: trimmed, kind },
          {
            onSuccess: (deck) => {
              setName('')
              onCreated(deck.id)
            },
          },
        )
      }}
      footer={
        <>
          <button type="button" className="secondary" onClick={onClose}>
            Отмена
          </button>
          <button type="submit" disabled={create.isPending || trimmed.length === 0}>
            {create.isPending ? 'Создаю…' : 'Создать колоду'}
          </button>
        </>
      }
    >
      <div className={styles.kinds} role="radiogroup" aria-label="Тип колоды">
        {KINDS.map((k) => (
          <button key={k} type="button" role="radio" aria-checked={kind === k} className={styles.kind} onClick={() => setKind(k)}>
            <b>{KIND_TITLE[k]}</b>
            <ul>
              {POINTS[k].map((p) => (
                <li key={p}>{p}</li>
              ))}
            </ul>
          </button>
        ))}
      </div>
      <label htmlFor="new-deck-name" className={styles.field}>
        Название
        <input id="new-deck-name" value={name} maxLength={80} placeholder="Например, Лунная колода" onChange={(e) => setName(e.target.value)} />
      </label>
      {create.isError && <p className={styles.error}>{deckErrorText(create.error)}</p>}
    </Modal>
  )
}
